const resources = {
    signInFree: 'Ouvrir une session pour profiter de l’expédition GRATUITE',
    signInAccount: 'Pas de compte?',
    signInAccountLink: 'Créer un compte',
    signInCTA: 'Ouvrir une session',
    status: 'Vous êtes',
    points: 'avec',
    join: 'S’inscrire à Beauty Insider',
    earn: 'pour accumuler des points à chaque achat.',
    ccRewards: 'Récompenses Carte de crédit',
    signInForPrefix: 'Ouvrez une session pour profiter de',
    fastFreeShipping: 'l’expédition GRATUITE RAPIDE',
    allOrders: 'sur toutes les commandes',
    noMinSpend: 'sans achat minimum requis.',
    newHere: 'Nouveau ici?',
    joinNow: 'S’inscrire'
};

export default function getResource(label) {
    return resources[label];
}
